/* eslint-disable import/order */
// redux ломается если что-то импортировано не так как он хочет
import React from 'react';
// при переезде на Vite стала падать ошибка https://github.com/TanStack/table/issues/3297, фикснулось этой библиотекой
import 'regenerator-runtime/runtime.js'
import { i18nReady } from '@vlapps/luna/src/app/translations/i18n';
import '@vlabs/uikit/assets/css/uikit.css';
import { createBrowserHistory } from 'history';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { setRoutes } from '@vlabs/shared/navigation/routes';
import { routes } from '@vlapps/luna/src/app/routes';
import { store } from '@vlapps/luna/src/app/store';

import { LunaApp } from '@vlapps/luna/src/app/LunaApp';
import * as serviceWorker from './serviceWorker';
import { registerErrorHandlers } from '@vlapps/luna/src/utils/errors';
import '@vlapps/luna/src/api/index';
import 'react-toastify/dist/ReactToastify.css';
import '@vlapps/luna/src/app/styles/index.sass';
import '@vlapps/luna/src/app/styles/toasts.sass';
import { restoreUserSession } from '@vlapps/luna/src/features/auth/store';
import 'video.js/dist/video-js.css';

setRoutes(routes);

registerErrorHandlers();

store.dispatch(restoreUserSession);

const history = createBrowserHistory();

const container = document.getElementById('root');
const root = createRoot(container);

// Ждём загрузки переводов (динамический import локалей по build-флагам __LOCALE_*__) перед первым рендером.
void i18nReady.then(() => {
  root.render(
    <React.StrictMode>
      <Router history={history}>
        <Provider store={store}>
          <LunaApp />
          <ToastContainer
            hideProgressBar
            position={toast.POSITION.TOP_LEFT}
          />
        </Provider>
      </Router>
    </React.StrictMode>,
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// expose store when run in Cypress
// FIXME: use only in test environment
if (window.Cypress) {
  window.cprs = {
    store,
    history,
  };
}
